module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-8.f8f0fde5.jpg";